import * as React from "react";
import TextField from "@mui/material/TextField";
import Button from "@mui/material/Button";
import Wrapper from "../../../components/Wrapper";
import { useState, useEffect } from "react";
import { CircularProgress, Container, MenuItem } from "@mui/material";
import title from "../../../components/title";
import { useDispatch, useSelector } from "react-redux";
import { AccountSet } from "../../../redux/reducer/AccountSetting";
import { ToastContainer, toast } from "react-toastify";
import { GetAccount } from "../../../redux/reducer/GetAccountDetails";
import { ValidateUser } from "../../../redux/reducer/ValidateUser";
import { bankDetailSchema } from "./validationSchema";
import { useFormik } from "formik";
import { isEqual } from "lodash";
import "./bankDetails.css";

// ✅ Pakistani banks (sorted alphabetically)
const pakistaniBanks = [
  "Allied Bank Limited",
  "Askari Bank Limited",
  "Al Baraka Bank (Pakistan) Limited",
  "Bank Alfalah Limited",
  "Bank Al Habib Limited",
  "Bank Islami Pakistan Limited",
  "Dubai Islamic Bank Pakistan Limited",
  "Faysal Bank Limited",
  "First Women Bank Limited",
  "Habib Bank Limited",
  "Habib Metropolitan Bank Limited",
  "JS Bank Limited",
  "MCB Bank Limited",
  "MCB Islamic Bank Limited",
  "Meezan Bank Limited",
  "National Bank of Pakistan",
  "Samba Bank Limited",
  "Silk Bank Limited",
  "Sindh Bank Limited",
  "Soneri Bank Limited",
  "Standard Chartered Bank (Pakistan) Limited",
  "Summit Bank Limited",
  "The Bank of Khyber",
  "The Bank of Punjab",
  "United Bank Limited",
];

export default function BankDetail() {
  title("Account Detail");
  const dispatch = useDispatch();
  const open = useSelector((state) => state.sidebar.open);
  const loaderSate = useSelector((state) => state?.accountSetting?.loading);

  const [initialData, setInitialData] = useState({
    bankName: "",
    accountName: "",
    accountNumber: "",
    ibanNumber: "",
  });

  const formik = useFormik({
    initialValues: initialData,
    enableReinitialize: true,
    validationSchema: bankDetailSchema,
    onSubmit: async (values) => {
      try {
        const res = await dispatch(AccountSet({ values }));
        if (
          res?.payload?.data?.message === "Account Detail Save Successfully"
        ) {
          toast.success(res?.payload?.data?.message, { autoClose: 300 });
          dispatch(ValidateUser({}));

          const accountRes = await dispatch(
            GetAccount({
              userId:
                sessionStorage.getItem("user_id") ||
                localStorage.getItem("user_id"),
            })
          );

          let { bankName, accountName, accountNumber, ibanNumber } =
            accountRes?.payload?.data?.data;

          const updatedData = {
            bankName: bankName || "",
            accountName: accountName || "",
            accountNumber: accountNumber || "",
            ibanNumber: ibanNumber || "",
          };

          setInitialData(updatedData);
        } else {
          toast.error(res?.payload?.data?.message, { autoClose: 300 });
        }
      } catch (err) {
        // Error handled silently
      }
    },
  });

  const {
    values,
    errors,
    handleBlur,
    handleChange,
    touched,
    handleSubmit,
    isValid,
  } = formik;

  useEffect(() => {
    dispatch(GetAccount({ userId: localStorage.getItem("user_id") })).then(
      (res) => {
        const { bankName, accountName, accountNumber, ibanNumber } =
          res?.payload?.data?.data;

        const backendData = {
          bankName: bankName || "",
          accountName: accountName || "",
          accountNumber: accountNumber || "",
          ibanNumber: ibanNumber || "",
        };

        setInitialData(backendData);
      }
    );
  }, [dispatch]);

  const isChanged = !isEqual(initialData, values);

  return (
    <>
      {loaderSate && (
        <div className="loader-overlay">
          <CircularProgress />
        </div>
      )}
      {/* <Wrapper open={open} /> */}
      <form onSubmit={handleSubmit}>
        <div
        // className={`${open ? "sidebar-open" : "sidebar-closed"} `}
        >
          {/* <div
            className="mainHeading"
            style={{
              display: "flex",
              justifyContent: "space-between",
              alignItems: "center",
              flexWrap: "wrap",
            }}
          >
            <h1>Account Detail</h1>
          </div> */}
          <Container maxWidth="sm" className="bank-details-container">
            <div className="bank-inputs">
              {/* ✅ Bank Name dropdown */}
              <TextField
                select
                id="bankName"
                label="Bank Name"
                variant="standard"
                name="bankName"
                value={values.bankName}
                onChange={handleChange}
                onBlur={handleBlur}
                error={touched.bankName && Boolean(errors.bankName)}
                helperText={touched.bankName && errors.bankName}
              >
                <MenuItem value="">Select Bank</MenuItem>
                {pakistaniBanks.map((bank) => (
                  <MenuItem key={bank} value={bank}>
                    {bank}
                  </MenuItem>
                ))}
              </TextField>

              <TextField
                id="accountName"
                label="Account Name"
                variant="standard"
                name="accountName"
                value={values.accountName}
                onChange={handleChange}
                onBlur={handleBlur}
                error={touched.accountName && Boolean(errors.accountName)}
                helperText={touched.accountName && errors.accountName}
                inputProps={{ maxLength: 50 }}
              />

              <TextField
                id="accountNumber"
                label="Account Number"
                variant="standard"
                name="accountNumber"
                value={values.accountNumber}
                onChange={handleChange}
                onBlur={handleBlur}
                error={touched.accountNumber && Boolean(errors.accountNumber)}
                helperText={touched.accountNumber && errors.accountNumber}
                inputProps={{ maxLength: 24 }}
              />

              <TextField
                id="ibanNumber"
                label="IBAN Number"
                variant="standard"
                name="ibanNumber"
                value={values.ibanNumber}
                onChange={handleChange}
                onBlur={handleBlur}
                error={touched.ibanNumber && Boolean(errors.ibanNumber)}
                helperText={touched.ibanNumber && errors.ibanNumber}
                inputProps={{ maxLength: 24 }}
              />
            </div>

            <Button
              className="bankButton"
              variant="contained"
              type="submit"
              disabled={!isChanged || !isValid}
            >
              Save
            </Button>
          </Container>
          <ToastContainer />
        </div>
      </form>
    </>
  );
}
